module.exports = __webpack_public_path__ + "static/media/bonus_large.1b1bda31.mp3";